<h4 class="title-2 mb-3">
  @if (isHhAuthForPacUser) {
    <span>Done!</span>
  } @else {
    <span>Authorization Request </span>
    @if (!isExternalUser || this.authRequest.authorizationDTO.isCurrentUserOwner) {
      {{ authRequest.authorizationDTO.authorizationNumber }}
    }
    <span> Submitted</span>
  }
</h4>
<p-panel [toggleable]="false" [header]="headerText">
  @if (!isPASCompleteFlow && !isHhAuthForPacUser) {
    <div class="flex items-center justify-center gap-4">
      @if (isExternalUser && !this.authRequest.authorizationDTO.isCurrentUserOwner) {
        <button
          pButton
          type="button"
          label="Return To Member Details"
          icon="pi pi-file"
          iconPos="left"
          (click)="navigateToMemberDetails()"
        ></button>
      }
      @if (!isExternalUser || this.authRequest.authorizationDTO.isCurrentUserOwner) {
        <button
          pButton
          type="button"
          label="View Authorization Request"
          icon="pi pi-file"
          iconPos="left"
          (click)="navigateToAuthorizationDetails()"
        ></button>
      }
      <button
        pButton
        type="button"
        label="Return To Home Page"
        icon="pi pi-home"
        iconPos="left"
        (click)="navigateToHome()"
      ></button>
    </div>
  }

  @if (isPASCompleteFlow) {
    <div class="flex justify-end gap-4">
      <button
        pButton
        severity="secondary"
        icon="pi pi-home"
        label="Return To Home Page"
        type="button"
        (click)="navigateToHome()"
      ></button>
      @if (!isExternalUser || this.authRequest.authorizationDTO.isCurrentUserOwner) {
        <button
          pButton
          severity="secondary"
          icon="pi pi-file"
          label="Return to Original Request"
          type="button"
          (click)="navigateToOriginalAuthDetails()"
        ></button>
        <button
          pButton
          icon="pi pi-file"
          label="View New Request"
          type="button"
          (click)="navigateToAuthorizationDetails()"
        ></button>
      }
    </div>
  }

  @if (isHhAuthForPacUser) {
    <p>Click a button below to view Home Health Authorization on Dashboard or return to PAC Authorization.</p>
  }
</p-panel>
@if (isHhAuthForPacUser) {
  <div class="flex mt-4 justify-end">
    <button
      pButton
      class="p-button-secondary mr-4"
      type="button"
      label="Return to PAC Authorization"
      icon="pi pi-home"
      iconPos="left"
      (click)="navigateToOriginalAuthDetails()"
  ></button>
  <button
    pButton
    class="p-button-secondary"
    type="button"
    label="View Home health Authorization"
    icon="pi pi-file"
    iconPos="left"
    (click)="navigateToProviderDashboard()"
  ></button>
</div>
}